import { useLocation, useNavigate } from 'react-router-dom';
import SignalMap from './SignalMap';
import Connectors from './Connectors';

// Merged "Signal & Data Registry": one nav destination with two tabs — Signal Routing (the
// signal-to-spine map) and Data Feeds (the commodity tripwire connectors). Both /signals and
// /connectors render this page so deep links keep working: the tab is derived from the path, and
// clicking a tab navigates to that path (URL always reflects the tab). Opened from the nav (/signals)
// it defaults to Signal Routing.
const TABS = [
  { key: 'routing', path: '/signals', label: 'Signal Routing' },
  { key: 'feeds', path: '/connectors', label: 'Data Feeds' },
] as const;

export default function SignalDataRegistry() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  // Normalize a trailing slash so /connectors and /connectors/ both resolve to the Data Feeds tab.
  const active = pathname.replace(/\/+$/, '') === '/connectors' ? 'feeds' : 'routing';

  return (
    <div>
      <div className="ph">Signal &amp; Data Registry</div>
      <div className="row" style={{ gap: 6, marginBottom: 14, borderBottom: '1px solid var(--line)', paddingBottom: 0 }}>
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => navigate(t.path)}
            aria-pressed={active === t.key}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '8px 12px',
              fontSize: 13,
              fontWeight: active === t.key ? 700 : 500,
              color: active === t.key ? 'var(--ink)' : 'var(--muted)',
              borderBottom: active === t.key ? '2px solid var(--azura)' : '2px solid transparent',
              marginBottom: -1,
            }}
          >
            {t.label}
          </button>
        ))}
      </div>
      {active === 'routing' ? <SignalMap /> : <Connectors />}
    </div>
  );
}
